import { useMutation } from 'react-query';
import { Http } from '../../services/Http';
import { EditUserPayload, User } from '../../types';
import { MUTATION_KEYS } from '../constants';
import { useInvalidateUsers } from './useUsers';

type Payload = {
  id: number;
  proxy?: number | null;
  /**
   * SVP-820: whether the assigned proxy may submit for this submitter. Sent together with `proxy` by
   * the Assign Proxy modal (the API resets the permission on a proxy change unless it is set in the
   * same request), or on its own by the switch in the Proxy Assignment table.
   */
  proxyCanSubmit?: boolean;
};

async function assignProxy({ id, proxy, proxyCanSubmit }: Payload): Promise<User[]> {
  const body: EditUserPayload = {
    ...(proxy !== undefined && { proxy }),
    ...(proxyCanSubmit !== undefined && { proxyCanSubmit }),
  };
  const { data } = await Http.axios.patch<EditUserPayload, User[]>(`/user/${id}`, body);
  return data;
}

export const useAssignProxyToOperatingPartner = () => {
  const invalidateUsers = useInvalidateUsers();
  return useMutation(assignProxy, {
    mutationKey: MUTATION_KEYS.ASSIGN_PROXY_TO_OPERATING_PARTNER_KEY,
    onSuccess: () => {
      invalidateUsers();
    },
  });
};
